module.exports = {"data":{"allMarkdownRemark":null},"pathContext":{"author":"/people/henry-debenham/"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/authors-henry-debenham.json
// module id = 1597
// module chunks = 180754660315618